export default __webpack_public_path__ + "static/media/overview2.9eb877ef.jpg";